import {
    InteractiveQuestion,
    QuestionsCollection,
} from '../../api/models/survey';
import {
    getBuiltSurvey,
    SELECTED_QUESTION_GROUP_BUYER,
    shouldIncludeInPaymentQuestions,
    SurveyQuestion,
} from '../../models/survey';
import { WithOrderNamespace } from '../../state/order';
import { WithSurveyNamespace } from '../../state/survey';
import { createSelector, getNamespaceValue } from '../utils/selector';
import {
    getInteractiveQuestionsByAttendeeId,
    getQuestionsCollection,
} from './pureSelectors';

export const getQuestionsForPayment = createSelector<
    Array<SurveyQuestion>,
    (
        questions: QuestionsCollection,
        interactiveQuestionsByAttendeeId: Record<
            string,
            Array<InteractiveQuestion>
        >,
        taxName?: string,
    ) => Array<SurveyQuestion>
>(
    (state: WithSurveyNamespace) => getQuestionsCollection(state),
    (state: WithSurveyNamespace) => getInteractiveQuestionsByAttendeeId(state),
    (state: WithOrderNamespace) => getNamespaceValue(state.order, 'taxIdName'),
    (questions, interactiveQuestionsByAttendeeId, taxIdName) =>
        getBuiltSurvey(
            questions,
            interactiveQuestionsByAttendeeId[SELECTED_QUESTION_GROUP_BUYER] ??
                [],
            shouldIncludeInPaymentQuestions,
            taxIdName,
        ),
);
